export default {
    listMailBox: state => state.mailBox,
    currentMailBoxSelected: state => state.currentMailBoxSelect,
    listMailReceived: state => state.listMailReceive,
    listMailSendBulk: state => state.listMailSendBulk,
    getMailThreadView: state => state.mailThreadView,
    getSearchFilter: state => state.searchFilter,
    getIndexGroupOpen: state => state.indexGroupOpen,
    selectedReceiveMail: state => state.selectedReceiveMail,
    mode: state => state.mode,
    listIncludeSubFolder: state => state.listIncludeSubFolder,
    mailDetail: state => state.mailDetail,
}